import React from 'react'
import { useGLTF } from '@react-three/drei'

export function SupervisorSkin(pos) {
  const { nodes, materials } = useGLTF('/models/supervisor2-transformed.glb')
  return (
    <group position={[pos[0],pos[1],pos[2]-0.7]}  dispose={null} rotation={[Math.PI/2,0,-Math.PI/2]}>
      <mesh geometry={nodes['socket_head_cap_screw_m3x16_iso_ISO_4762_M3_x_16_-_16NA2-70020'].geometry} material={materials.PaletteMaterial002} />
      <mesh geometry={nodes['socket_head_cap_screw_m3x16_iso_ISO_4762_M3_x_16_-_16NA2-70020_1'].geometry} material={materials.PaletteMaterial001} />
      </group>
  )
}

useGLTF.preload('/models/supervisor2-transformed.glb')
